import React from 'react';
import { TextField } from '../TextField';
import { PhoneFieldProps } from './interface';

// NOTE: We cannot use import with this package as it only
// supports ESM. Even though we transpile our code to CJS with require
// something flops and consumer packages fail (or their storybook fails)
// when loading ui-kit components.
const { useMask } = require('@react-input/mask');

export const PhoneField = ({ placeholder = 'Phone number', ...rest }: PhoneFieldProps) => {
  const inputRef = useMask({ mask: '+1 (___) ___-____', replacement: { _: /\d/ } });

  return <TextField placeholder={placeholder} {...rest} inputRef={inputRef} />;
};
